(function certificateDetailControllerDefinition() {
    'use strict';

    angular.module('Certificate')
        .controller('CertificateDetailController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processCustomerService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', '$translate', 'alerts',
            function certificateDetailController($filter, $state, $scope, $stateParams, errors, processCustomerService, fileWorkflowService, auth, configViewService, $q, $translate, alerts) {

                $scope.actions = {
                    delete: false,
                    edit: false,
                    editName: 'Edit'
                };

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.loadCertificate = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    processCustomerService.getById($stateParams.id).then(function (result) {
                        $scope.certificate = result;
                        defered.resolve();
                    }, function (error) {
                        errors.showError(error);
                        defered.reject();
                        //$scope.cancel();
                    });

                    return promise;
                };

                $scope.loadConfigView = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    configViewService.getById('CPPCertificate').then(function (result) {
                        $scope.configView = result;
                        defered.resolve();
                    }, function (error) {
                        errors.showError(error);
                        defered.reject();
                    });

                    return promise;
                };

                $scope.loadActions = function (processType, process) {
                    var result = $filter('filter')(processType.groupStates, function (item) {
                        return item.ids.indexOf(process.stateId) > -1;
                    }, true);

                    if (result.length > 0) {
                        $scope.actions = {
                            delete: result[0].delete,
                            edit: result[0].edit,
                            editName: result[0].editName
                        };
                    }
                };

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId)
                };

                $scope.cancel = function () {
                    $state.go('certificate-find');
                };

                $scope.edit = function () {
                    //establecer clave roja certificado
                    $state.go('certificate-edit', { id: $scope.certificate.id });
                };

                $scope.load = function () {
                    $scope.userId = auth.getUserId();
                    $scope.canContinue = auth.isInRole('CERTIFICATECUSTOMER CONTINUE');
                    $scope.writePermission = auth.isInRole('CERTIFICATECUSTOMER WRITE');

                    var metadatas = [];

                    $q.all([$scope.loadCertificate(), $scope.loadConfigView()]).then(function () {
                        var result = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.certificate.certificateTypeId }, true);
                        if (result.length == 0) {
                            $scope.certificate.metadataValues = metadatas;
                            return;
                        }

                        result[0].metadatas.forEach(function (certificateMetadata) {
                            if (certificateMetadata.detailCriteria) {
                                var metadataFound = $filter('filter')($scope.certificate.metadataValues, { systemName: certificateMetadata.systemName }, true);

                                var value = null;
                                var desc = null;

                                if (metadataFound.length > 0) {
                                    value = metadataFound[0].value;
                                    desc = metadataFound[0].description;
                                }

                                metadatas.push({
                                    metadataId: certificateMetadata.metadataId,
                                    type: certificateMetadata.metadataType.toLowerCase(),
                                    name: certificateMetadata.detailCriteria.name,
                                    maskOptions: certificateMetadata.maskOptions,
                                    systemName: certificateMetadata.systemName,
                                    order: certificateMetadata.detailCriteria.order,
                                    value: value,
                                    description: desc,
                                    mask: certificateMetadata.detailCriteria.mask
                                });
                            }
                        });

                        metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        $scope.certificate.metadataValues = metadatas;

                        $scope.loadActions(result[0], $scope.certificate);
                    });
                };

                $scope.load();
            }
        ]);
})();
